import { Grid, Card, CardHeader, CardContent, Box, Button } from '@mui/material';
import { Form, useNotify, useRedirect, useTranslate } from 'react-admin';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import CustomLoginEmailInput from '@/components/login/CustomLoginEmailInput';
import MaasloopIcon from '@/assets/icons/maasloop.svg?react';
import RevloopIcon from '@/assets/icons/revloop.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';
import LanguageSwitcher from '@/components/global/menu/LanguageSwitcher.jsx';

const apiUrl = import.meta.env.VITE_API_URL;
const ForgetPasswordPage = () => {
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();
    const translate = useTranslate();

    const handleForgetPassword = async ({ email }) => {
        setLoading(true);
        const request = new Request(`${apiUrl}/user/forget-password`, {
            method: 'POST',
            body: JSON.stringify({ email }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        const response = await fetch(request);
        setLoading(false);

        if (false === response.ok) {
            const responseBody = await response.json();
            notify(responseBody.errors[0].message, { type: 'error' });
            return;
        }

        redirect('/reset-password-info');
    };

    return (
        <>
            <Box sx={{ position: 'fixed', top: 32, right: 32 }}>
                <LanguageSwitcher />
            </Box>
            <Box height={'98vh'} display='flex' alignItems='center' justifyContent='center' gap={4} p={2}>
                <Card
                    sx={{
                        width: 400,
                        borderRadius: '32px',
                        paddingInline: '40px',
                        paddingBlock: '46px',
                        boxShadow: Palette.boxShadow.elevation3,
                    }}
                >
                    <Box sx={{ display: 'flex', gap: '16px', marginBottom: '26px' }}>
                        <RevloopIcon />
                        <MaasloopIcon />
                    </Box>
                    <CardHeader
                        title={translate('auth.enterEmailTitle')}
                        sx={{ padding: 0, marginBottom: '13px' }}
                        titleTypographyProps={{ fontSize: '18px' }}
                    />
                    <CardContent sx={{ padding: 0, '&:last-child': { padding: 0 } }}>
                        <Form mode='onChange' reValidateMode='onChange' onSubmit={handleForgetPassword}>
                            <Grid container>
                                <Grid
                                    item
                                    sm={12}
                                    rowSpacing={5}
                                    sx={{ width: '100%', '& .MuiFormLabel-root[data-shrink="false"]': { backgroundColor: Palette.white, width: '100%' } }}
                                >
                                    <CustomLoginEmailInput isRequired={true} />
                                </Grid>
                                <Grid item sm={12}>
                                    <Button
                                        color='primary'
                                        size='small'
                                        type='submit'
                                        variant='contained'
                                        fullWidth
                                        sx={{ marginRight: 4, padding: '14px', marginTop: '20px' }}
                                        disabled={loading}
                                    >
                                        {translate('auth.sendResetLink')}
                                    </Button>
                                    <Button
                                        color='secondary'
                                        size='small'
                                        component={Link}
                                        to='/login'
                                        variant='contained'
                                        fullWidth
                                        sx={{
                                            marginRight: 4,
                                            padding: '14px',
                                            marginTop: '20px',
                                            textDecoration: 'none',
                                            '&:hover': {
                                                color: 'inherit',
                                            },
                                        }}
                                        disabled={loading}
                                    >
                                        {translate('auth.backToLogin')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    </CardContent>
                </Card>
            </Box>
        </>
    );
};

export default ForgetPasswordPage;
